import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseService } from '../shared-service/base.service';
import { Router } from "@angular/router";
import { throwError ,catchError } from 'rxjs';
import { AuthOIDCService } from "../auth/authOIDC.service";

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private bs: BaseService,
    private router: Router,
    private authOIDCService: AuthOIDCService
  ) {
  }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //do whatever you want with the HttpRequest       
    if (this.bs.menuKey != "" && this.bs.submenuKey != "" && !(req.body instanceof FormData)) {
      let params = {
        menuId: this.bs.menuKey,
        submenuId: this.bs.submenuKey
      }
      console.log('Intercepted!', req);
      const reqCloned = this.handleBodyIn(req, params);
      const copiedReq = reqCloned;

      //return next.handle(copiedReq);
      return next.handle(this.addToken(copiedReq)).pipe(catchError((context => {
        if (context instanceof HttpErrorResponse && (context.status === 500)) {
          this.bs.log('error', 'UnAuthorized Access of Content.');
        }
        else {
          this.bs.log('error', 'Some error occurred. Please contact to administrator.');
        }
        return throwError(context);
      })));

    }
    else {
      return next.handle(this.addToken(req));
    }
  }

  handleBodyIn(req: HttpRequest<any>, params:any) {
    if (req.method.toLowerCase() === 'post') {
      req = req.clone({
        body: { ...req.body, ...params }
      })
    }
    console.log(req);
    return req;
  }

  addToken(req: HttpRequest<any>) {
    const token = this.authOIDCService.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return req.clone({ headers });
  }
}

